const DISPLAY = "'Barlow Condensed', sans-serif"
const BLUE    = '#4F8EF7'

export default function Logo({ variant = 'full', theme = 'light', size = 40 }) {
  const ink      = theme === 'dark' ? '#FFFFFF' : '#0A0A0A'
  const gap      = Math.round(size * 0.3)
  const fontSize = Math.round(size * 0.5)

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap }}>
      <img src="/logo.svg" alt="Insightball" style={{ width: size, height: size, display: 'block' }} />
      {variant === 'full' && (
        <span style={{
          fontFamily: DISPLAY, fontSize, fontWeight: 800,
          letterSpacing: '.04em', textTransform: 'uppercase',
          color: ink, lineHeight: 1, whiteSpace: 'nowrap',
        }}>
          INSIGHT<span style={{ color: BLUE }}>BALL</span>
        </span>
      )}
    </span>
  )
}
